import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import CardBox from "@material-ui/core/Card";
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import FormHelperText from "@material-ui/core/FormHelperText";
import Logo from '../../assets/logo.svg';
//import bgImg from '../../assets/scmBgImg.png';
import TeamsLogo from '../../assets/teams.png';
import {
    AuthenticatedTemplate,
    UnauthenticatedTemplate,
    useMsal,
} from "@azure/msal-react";
import { AuthProvider, msalConfig } from "../Authentication";


const useStyles = makeStyles((theme) => ({
    container: {
        padding: theme.spacing(5),
    },
    field: {
        marginLeft: '20px',
        marginRight: '15px',
        width: 325,
    },
}));

export default function Login(props) {
    const { handleSubmit, register, control, errors } = useForm([]);
    const [password, setPassword] = React.useState(true);
    const classes = useStyles();
    const { instance, accounts } = useMsal();
    const onSubmit = (data) => {
        // console.log(data);
        // props.onLoginChange("user");

        // return (
        //     <AzureAD
        //         provider={AuthProvider}
        //         forceLogin={true}
        //         authenticatedFunction={authenticatedFunction}
        //     ></AzureAD>
        // );
    };

    const loginMS = (data) => {
        console.log('your in the login ms', data);
        instance.loginRedirect(msalConfig).catch((e) => {
            console.log('error from msal config', e);
        });
    }

    // const handleChange = value => {
    //     console.log("event", value);
    //     const strongRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%\^&\*])(?=.{8,})/;
    //     if (strongRegex.test(value)) {
    //         setPassword(false);
    //         //return false;
    //     }
    // }
    // const isValid = (event) => {
    //     console.log("event", event);
    //     const strongRegex = new RegExp(" ^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%\^&\*])(?=.{8,})");
    //     if (strongRegex.test(event)) {
    //         //setPassword(false);
    //         return false;

    //     }

    //}
    return (
        <div class="flexCont">
            <div class="d-flex flex-column flex-root">
                <div class="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white">
                    <div class="content d-flex flex-column w-100 login-bg SCM-bg">
                        <img src={Logo} width='80' height='80' />

                        <div class="login-aside d-flex flex-row-auto ">
                            <div class="d-flex flex-column-fluid flex-column loginform">
                                <div class="d-flex flex-column-fluid flex-column flex-center">
                                    {/* <CardBox > */}
                                    <div class="loginTitle">
                                        <h2>Welcome to Railways!</h2>
                                        <p>Login to Your Account to continue</p>
                                    </div>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12}>
                                            <Button color="primary" fullWidth onClick={() => loginMS()} variant="contained" >
                                                Let me in
                                            </Button>
                                        </Grid>
                                    </Grid>
                                    {/* <form onSubmit={handleSubmit(onSubmit)} noValidate>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12}>
                                                <Button color="primary" fullWidth onClick={() => loginMS()} variant="contained" >
                                                    Let me in
                                                </Button>
                                            </Grid>

                                            <div class="businessLogin" style={{ display: 'hidden' }}>
                                                <div class="or"><span>OR</span></div>
                                                <p>Login with Business Account:</p>
                                                <img  src={TeamsLogo} width='45' height='45' />
                                            </div>
                                        </Grid>
                                    </form> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};